import { formatCurrency } from '@nudool/shared';

const SUB_CENT_FRACTION_DIGITS = 4;
const ONE_CENT = 0.01;

/** A unit cost to the cent, or to four places below a cent so a gram of distillate does not read $0.00. */
export function formatUnitCost(unitCost: number): string {
  return (
    formatCurrency(
      unitCost,
      undefined,
      unitCost > 0 && unitCost < ONE_CENT
        ? { maximumFractionDigits: SUB_CENT_FRACTION_DIGITS }
        : {},
    ) ?? ''
  );
}
